import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CampaignPhase, SubType } from '@shared/constants';
import {
  AnyChallenge,
  SelectionButtonConfig,
  SelectionButtonDynamicComponent,
} from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';
import { Variant3Component } from './variant3/variant3.component';
import { Variant5Component } from './variant5/variant5.component';
import { Variant6Component } from './variant6/variant6.component';
import { Variant7Component } from './variant7/variant7.component';
import { Variant8Component } from './variant8/variant8.component';

@Component({
  imports: [NgComponentOutlet],
  selector: 'b2c-selection-button',
  templateUrl: './selection-button.component.html',
})
export class SelectionButtonComponent extends BaseComponent {
  challenge = input.required<AnyChallenge>();

  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  // Resolved by the challenge card: only the 2nd variant renders a sub type
  subType = input<SubType>(SubType.DEFAULT);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  protected config: SelectionButtonConfig =
    this.loyaltyChallengeConfig.components.challenges.elements.selectionButton;

  public components: Signal<
    SelectionButtonDynamicComponent<SelectionButtonConfig>
  > = computed(() => {
    return {
      [this.Variants.VARIANT_1]: {
        component: Variant1Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
      [this.Variants.VARIANT_2]: {
        component: Variant2Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          subType: this.subType(),
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
      [this.Variants.VARIANT_3]: {
        component: Variant3Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
      [this.Variants.VARIANT_5]: {
        component: Variant5Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
      [this.Variants.VARIANT_6]: {
        component: Variant6Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
      [this.Variants.VARIANT_7]: {
        component: Variant7Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
      [this.Variants.VARIANT_8]: {
        component: Variant8Component,
        inputs: {
          phase: this.phase(),
          config: this.config,
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
        },
      },
    };
  });
}
